'use client';
/** @jsxImportSource @emotion/react */

import type { RadioGroupProps as MuiRadioGroupProps } from '@mui/material/RadioGroup';

import MuiRadioGroup from '@mui/material/RadioGroup';

interface RadioGroupProps extends MuiRadioGroupProps {
  component?: React.ElementType;
}

export type { RadioGroupProps };

export const RadioGroup: React.FC<RadioGroupProps> = MuiRadioGroup;

RadioGroup.displayName = 'RadioGroup';
